import {
  AnimationT,
  firstQuickActionVariants,
  secondQuickActionVariants
} from '@components/suggestions/animations/quickActionAnimation';
import palette from '@lib/core/src/theme/palette';
import { motion, AnimationControls } from 'framer-motion';

interface QuickActionAnimationWrapperProps {
  children: React.ReactNode;
  quickActionId: string;
  index: number;
  firstQuickActionControls: AnimationControls;
  secondQuickActionControls: AnimationControls;
}

const QuickActionAnimationWrapper = ({
  children,
  quickActionId,
  index,
  firstQuickActionControls,
  secondQuickActionControls
}: QuickActionAnimationWrapperProps) => (
  <motion.div
    key={quickActionId}
    initial={AnimationT.Initial}
    variants={index === 0 ? firstQuickActionVariants : secondQuickActionVariants}
    animate={index === 0 ? firstQuickActionControls : secondQuickActionControls}
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      position: 'absolute',
      zIndex: 1000 - index,
      width: '100%',
      height: '100%',
      backgroundColor: palette.white,
      border: `1px solid ${palette.grey[1200]}`,
      borderRadius: '16px',
      padding: '16px 12px 12px 12px'
    }}
  >
    {children}
  </motion.div>
);

export default QuickActionAnimationWrapper;
